export const ICON_LABELS = Object.freeze({
  add: 'Aggiungi',
  arrowDown: 'Espandi',
  attached: 'Allegati',
  bell: 'Notifiche',
  calendar: 'Calendario',
  clients: 'Clienti',
  coins: 'Contabilità',
  pending: 'Da accettare',
  dealsActive: 'Affari in corso',
  dealsCompleted: 'Affari completati',
  checkCircle: 'Conferma',
  completed: 'Completato',
  completedAction: 'Completa',
  config: 'Configura',
  crossCircle: 'Chiudi',
  dashboard: 'Dashboard',
  dealsProposals: 'Proposte affari',
  delete: 'Elimina',
  document: 'Documenti',
  documentsSigned: 'Documenti firmati',
  download: 'Scarica',
  edit: 'Modifica',
  finance: 'Finanze',
  filter: 'Filtri',
  filterDecoration: 'Filtri',
  folder: 'Cartella',
  inProgress: 'In corso',
  loss: 'Uscite',
  logout: 'Esci',
  mail: 'Email',
  menu: 'Menu',
  note: 'Nota',
  notes: 'Commenti',
  ownership: 'Trasferisci proprietà',
  password: 'Password',
  phone: 'Telefono',
  powerOff: 'Attiva o disattiva',
  preview: 'Visualizza',
  profit: 'Entrate',
  reset: 'Ripristina',
  review: 'Da verificare',
  save: 'Salva',
  search: 'Cerca',
  settings: 'Impostazioni',
  sackDollar: 'Uscite',
  suppliers: 'Fornitori',
  taskIcon: 'Task',
  team: 'Team',
  usdCircle: 'Movimento',
  user: 'Utente',
  users: 'Utenti',
  upload: 'Carica',
});
const ALIASES = {
  accounting: 'coins',
  expenses: 'sackDollar',
  tasks: 'taskIcon',
  documents: 'document',
  accept: 'completed',
  reject: 'crossCircle',
  key: 'password',
  complete: 'completedAction',
  close: 'crossCircle',
  filters: 'filter',
  resend: 'mail',
  power: 'powerOff',
  theme: 'settings',
};
export function getIconLabel(key = '') {
  const name = key.split('.').pop();
  return ICON_LABELS[ALIASES[name] || name] || '';
}
export function actionIconForLabel(label = '') {
  const text = label.toLocaleLowerCase('it');
  if (/rifiuta|annulla (incasso|uscita|fattura|movimento)/.test(text)) return 'actions.reject';
  if (/annull|elimina|rimuovi|archivia|cancella/.test(text)) return 'delete';
  if (/registra (incasso|pagamento)|accetta|approva|completa/.test(text)) return 'completed';
  if (/salva|crea|conferma modifiche|aggiorna/.test(text)) return 'save';
  if (/indietro|torna/.test(text)) return 'arrowDown';
  if (/chiudi/.test(text)) return 'crossCircle';
  if (/modifica/.test(text)) return 'edit';
  if (/scarica|download|esporta/.test(text)) return 'download';
  if (/carica|upload/.test(text)) return 'upload';
  if (/allega/.test(text)) return 'attached';
  if (/comment|not[ae]/.test(text)) return 'notes';
  if (/invia|email/.test(text)) return 'mail';
  if (/conferma|completa|promuovi|accetta|approva/.test(text)) return 'completed';
  if (/aggiungi|nuov/.test(text)) return 'add';
  if (/paga|pagamento|incasso/.test(text)) return 'usdCircle';
  return 'preview';
}
